export default __webpack_public_path__ + "img/bg-desktop-illustration-light.svg";